import React from 'react'
import { css } from 'styled-system/css'
import { useDispatch } from 'react-redux'
import { PageSource } from '@mindfulchefuk/analytics'
import { CMSImage } from '@mindfulchefuk/features/CMS/components'
import { CMSBanner } from '@mindfulchefuk/features/CMS/interfaces'
import { dateFormats } from '@mindfulchefuk/lib/dateFormats'
import { setDeliveryDate } from '@mindfulchefuk/actions/basketActions'
import { useCMSBannerRedirect } from '@mindfulchefuk/features/CMS/hooks/useCMSBannerRedirect'
import { CMSBannerLinkWrapper } from '@mindfulchefuk/features/CMS/components/CMSBannerLinkWrapper'
import { trackAnalyticsEvent } from '@mindfulchefuk/utils/analytics/amplitude/amplitudeAdapter'

export const OnboardingChooseRecipesBannerImage = ({
  banner,
}: {
  banner: CMSBanner | null
}) => {
  const dispatch = useDispatch()

  const DEFAULT_IMAGE = 'defaults/choose-recipes-banner.jpg'

  const { redirectURL, targetDeliveryDate } = useCMSBannerRedirect(
    banner?.redirectConfig
  )

  if (banner) {
    return (
      <CMSBannerLinkWrapper
        href={redirectURL}
        width="100%"
        position="relative"
        overflow="hidden"
        onClick={() => {
          trackAnalyticsEvent({
            name: 'choose recipes banner clicked',
            data: {
              'banner name': banner?.title,
              'campaign name': banner?.campaign ? banner?.campaign.title : '',
              'page source': 'choose recipes page' as PageSource,
              'customer preferences': [''],
            },
          })
          dispatch(setDeliveryDate(dateFormats.iso(targetDeliveryDate)))
        }}
      >
        <CMSImage
          className={css({
            objectFit: 'cover',
            height: '100%',
            maxHeight: '100%',
          })}
          width={640}
          data-testid="choose-recipes-header-img"
          src={banner.image.src}
          alt={banner.image.altText}
          sources={banner.image.sources}
        />
      </CMSBannerLinkWrapper>
    )
  }

  return (
    <CMSImage
      className={css({
        objectFit: 'cover',
        height: '100%',
        maxHeight: '100%',
      })}
      width={640}
      data-testid="choose-recipes-header-img"
      src={DEFAULT_IMAGE}
      alt="Unboxed Mindful Chef recipe box with booklet, vegetables and protein on display"
      sources={[]}
    />
  )
}
